import {
  createMatchedPFGrantsAsync,
  createMatchedPFGrantsAsyncBuilder,
  fetchMatchedPFAsync,
  fetchMatchedPFAsyncBuilder,
  updateMatchedPFAsync,
  updateMatchedPFAsyncAsyncBuilder,
} from './asyncRequests'
import { IMatchedPF } from '../../types'
import { createSlice } from '@reduxjs/toolkit'

export interface MatchedPFInitialState {
  data: IMatchedPF
  loading: boolean
  success: boolean
  error: string
}

const initialState: MatchedPFInitialState = {
  data: {} as IMatchedPF,
  loading: false,
  success: false,
  error: '',
}

export const MatchedPFSlice = createSlice({
  name: 'matchedPFSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchMatchedPFAsyncBuilder(builder)
    createMatchedPFGrantsAsyncBuilder(builder)
    updateMatchedPFAsyncAsyncBuilder(builder)
  },
})

export const MatchedPFActions = {
  ...MatchedPFSlice.actions,
  fetchMatchedPFAsync,
  updateMatchedPFAsync,
  createMatchedPFGrantsAsync
}

export const MatchedPFReducer = MatchedPFSlice.reducer
